export function SplashScreen() {
  return (
    <main
      className="flex min-h-dvh items-center justify-center bg-[var(--background)]"
      aria-label="Loading Carmel Work"
      aria-live="polite"
    >
      <div className="flex flex-col items-center gap-4">
        {/* Compact logo with subtle spin ring */}
        <div className="relative flex h-12 w-12 items-center justify-center">
          <div className="absolute inset-0 rounded-xl border border-[var(--color-primary-border)] animate-[spin_6s_linear_infinite] motion-reduce:animate-none" />
          <div className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--color-primary)] shadow-[0_4px_16px_rgba(142,73,245,0.25)]">
            <img src="/carmel-logo-white.png" alt="" className="size-4 object-contain" />
          </div>
        </div>
        {/* Minimal loading dots */}
        <div className="flex items-center gap-1" aria-hidden="true">
          <span className="h-1 w-1 animate-pulse rounded-full bg-[var(--color-primary)]" />
          <span className="h-1 w-1 animate-pulse rounded-full bg-[var(--color-primary)] [animation-delay:150ms]" />
          <span className="h-1 w-1 animate-pulse rounded-full bg-[var(--color-primary)] [animation-delay:300ms]" />
        </div>
      </div>
    </main>
  );
}
